import { LEGACY_DEFAULT_AUTH_URL } from '@cli-constants/scaffolding.js'
import { readEnvVar } from '@cli-utils/files.js'

export function shouldOverwriteAuthUrl(cwd: string, devPort: number): boolean {
  const existingAuthUrl = readEnvVar(cwd, 'BETTERSTART_AUTH_URL')
  if (!existingAuthUrl) return false

  return (
    existingAuthUrl === LEGACY_DEFAULT_AUTH_URL && existingAuthUrl !== `http://localhost:${devPort}`
  )
}
